(function () {
  function groupKey(card) {
    return (
      card.closest(".swiper-wrapper") ||
      card.closest("[class*='m:grid']") ||
      card.parentElement
    );
  }

  function visibleActionWrapper(card) {
    var wrappers = card.querySelectorAll(".m-product-card__action-wrapper");
    var best = null;
    var bestHeight = 0;
    wrappers.forEach(function (w) {
      var h = w.getBoundingClientRect().height;
      if (h > bestHeight) {
        bestHeight = h;
        best = w;
      }
    });
    return best;
  }

  function alignCards() {
    var cards = document.querySelectorAll(".m-product-card");
    var groups = new Map();

    cards.forEach(function (card) {
      var wrapper = visibleActionWrapper(card);
      if (!wrapper) return;
      var button = wrapper.querySelector("button, a");
      if (!button) return;
      wrapper.style.paddingTop = "";
      var key = groupKey(card);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push({ card: card, wrapper: wrapper, button: button });
    });

    groups.forEach(function (items) {
      if (items.length < 2 || items.length > 8) return;
      var offsets = items.map(function (item) {
        return (
          item.button.getBoundingClientRect().top -
          item.card.getBoundingClientRect().top
        );
      });
      var max = Math.max.apply(null, offsets);
      items.forEach(function (item, i) {
        var delta = max - offsets[i];
        item.wrapper.style.paddingTop = delta > 1 ? delta + "px" : "";
      });
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(alignCards, 150);
  }

  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule);
  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("DOMContentLoaded", schedule);
  if (document.readyState === "complete") schedule();

  // Third-party app widgets (reviews, bundle pickers, etc.) can inject
  // content asynchronously after the initial alignment pass. Re-align
  // whenever a product card's content actually changes.
  if ("MutationObserver" in window) {
    var observer = new MutationObserver(schedule);
    var start = function () {
      observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener("DOMContentLoaded", start);
  }

  // Some app widgets (e.g. bundle pickers) resize themselves without any
  // node being added/removed (just their own internal layout settling),
  // which a MutationObserver won't catch. Watch each action area directly.
  if ("ResizeObserver" in window) {
    var resizeObserver = new ResizeObserver(schedule);
    var watchWrappers = function () {
      document
        .querySelectorAll(".m-product-card__action-wrapper")
        .forEach(function (el) {
          resizeObserver.observe(el);
        });
    };
    window.addEventListener("load", watchWrappers);
    document.addEventListener("shopify:section:load", watchWrappers);
    if (document.readyState === "complete") watchWrappers();
  }

  [600, 1500, 3000, 5000].forEach(function (delay) {
    window.setTimeout(alignCards, delay);
  });
})();
